import base from './base'

export default {
  ...base,
  force_update: {
    type: ['boolean'],
    default: () => false
  },
  os: {
    type: ['undefined', 'string'],
  },
  min_os_version: {
    type: ['undefined', 'number'],
  },
  os_version: {
    type: ['undefined', 'number'],
  },
  version_no: {
    type: ['undefined', 'number']
  },
  version_no_str: {
    type: ['undefined', 'string']
  },
  web_url: {
    type: ['undefined', 'string']
  },
  android_url: {
    type: ['undefined', 'string']
  },
  features: {
    type: ['array'],
    default: () => []
  },
}
